    
<template>
<div class="ui large modal" id="PartnerModal"> <!--ui fullscreen modal -->

     <i class="close icon" @click="onClose()" ></i>

 
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <div class="ui form segment">
    <app-header v-if="showMenu" ></app-header>

    <div class="ui attached segment">
       
    <div class="three fields">
        <div class="field">
            <label>Partner Type</label>
            <select class="ui input" style="width:340px"  v-model="partnerTypeSelected"  >
                      <option v-for="partnerType in partnerTypes" v-bind:value="partnerType.partnerTypeId" v-bind:key="partnerType.partnerTypeId" >
                          {{ partnerType.name }}
                      </option>
                    </select>
        </div>
        
  
  </div>
        <div class="three fields">
        <div class="field">
            <label>Code</label>
            <input placeholder="Notes"  style="width:340px" name="_code" type="text"  ref="ipCode">
        </div>
         <div class="field">
            <label>Email</label>
            <input placeholder="Email"  style="width:340px" name="_email" type="text"  ref="ipEmail">
        </div>
         <div class="field">
            <label>Contact Name</label>
            <input placeholder="Contact Name"  style="width:340px" name="_contactName" type="text"  ref="ipContactName">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Contact Phone</label>
            <input placeholder="Contact Phone"  style="width:340px" name="_contactPhone" type="text"  ref="ipcontactPhone">
        </div>
         <div class="field">
            <label>Communication Mode</label>
            <input placeholder="Communication Mode"  style="width:340px" name="_communicationMode" type="text"  ref="ipCommunicationMode">
        </div>
         <div class="field">
            <label>Security Code</label>
            <input placeholder="Security Code"  style="width:340px" name="_secirityCode" type="text"  ref="ipSecurityCode">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Name</label>
            <input placeholder="Name"  style="width:340px" name="_name" type="text"  ref="ipName">
        </div>
         <div class="field">
            <label>Endpoint Url</label>
            <input placeholder="EndPointUrl"  style="width:340px" name="_endPointUrl" type="text"  ref="ipEndPointUrl">
        </div>
         <div class="field">
            <label>Active</label>
                <select class="ui input" style="width:340px"  v-model="activeStatusSelected"  >
                      <option v-for="statusType in activeStatus" v-bind:value="statusType.statusId" v-bind:key="statusType.statusId" >
                          {{ statusType.name }}
                      </option>
              </select>
        </div>
  
  </div>

   <div class="three fields">
        <div class="field">
            <label>Mode</label>
           
            <select class="ui input" style="width:340px"  v-model="modeTypeSelected"  >
                      <option v-for="modeType in modes" v-bind:value="modeType.modeTypeId" v-bind:key="modeType.modeTypeId" >
                          {{ modeType.name }}
                      </option>
            </select>
        </div>
         <div class="field">
            <label>Xref Code</label>
            <input placeholder="Xref Code"  style="width:340px" name="_xrefCode" type="text"  ref="ipXrefCode">
        </div>
         <div class="field">
           
        </div>
  
  </div>

  <div class="three fields">
        <div class="field">
            <label>Supplier Identity</label>
            <input placeholder="Supplier Identity"  style="width:340px" name="_supplierIdentity" type="text"  ref="ipSupplierIdentity">
        </div>
         <div class="field">
            <label>Buyer Identity</label>
            <input placeholder="Buyer Identity"  style="width:340px" name="_buyerIdentity" type="text"  ref="ipBuyerIdentity">
        </div>
         <div class="field">
            <label>Received Location</label>
            <input placeholder="Received Location"  style="width:340px" name="_receivedLocation" type="text"  ref="ipReceivedLocation">
        </div>
  
  </div>

        
        <br />
       <div class="four fields">
            <div class="field">
              <div class="ui primary submit button" @click="createPartner()">Create </div>
                <button class="ui button" @click="resetControls" >Reset</button> 
             </div>
      </div>
      <div class="ui modal">
        <!-- <i class="close icon"></i>  -->
        <div class="header">
            Do you want to continue?
        </div>
        
        <div class="actions">
            <div class="ui black deny button">
            Nope
            </div>
            <div class="ui positive right labeled icon button">
            Yes
            <i class="checkmark icon"></i>
            </div>
        </div>
      </div>
    </div> 

  </div>
</div>
</div>
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'

export default {
components: {
    appHeader: Header
  },
data () {
    return {
      loaded : "2",
      showMenu :false,
      tokenExpired : 0,
      showMessage :0,
      input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
     
      partnerTypes : [
    	{ partnerTypeId: 0, name: 'Invoice Cxml Processing Set Up' },
      { partnerTypeId: 1, name: 'PO Cxml Processing Set up' }
    ],
    partnerTypeSelected : "",
     modes : [
    	{ modeTypeId: 'QA', name: 'QA' },
      { modeTypeId: 'PR', name: 'PROD' }
    ],
    modeTypeSelected : "",
     activeStatus : [
    	{ statusId: 1, name: 'Active' },
      { statusId: 0, name: 'In-Active' }
    ],
    activeStatusSelected : ""
     
    }
  },
  methods: {
   
    
    
   
    sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },

    checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    resetControls () {
     this.checkTokenExpired();
     this.$refs.ipCode.value = "";
     this.$refs.ipEmail.value = "";
     this.$refs.ipContactName.value = "";
     this.$refs.ipcontactPhone.value = "";
     this.$refs.ipCommunicationMode.value = "";
     this.$refs.ipSecurityCode.value = "";
     this.$refs.ipName.value = "";
     this.$refs.ipEndPointUrl.value = "";
     this.$refs.ipXrefCode.value = "";
     this.$refs.ipSupplierIdentity.value = "";
     this.$refs.ipBuyerIdentity.value = "";
     this.$refs.ipReceivedLocation.value = "";
     this.partnerTypeSelected = "0";
     this.modeTypeSelected = "QA";
     this.activeStatusSelected = "1";

    },
    createPartner(){ 
      
      
       if(this.showMessage == 0){
      swal({
        title: "",
        text: "Are you sure, to create Member Vendor Configuration?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Create it!",
        closeOnConfirm: true
      },() => {
         
          axios({ method: "POST", "url": Vue.prototype.$hostname +  "createpartner", 
                "data": {
                type : this.partnerTypeSelected,
                code : this.$refs.ipCode.value.trim() ,
                email : this.$refs.ipEmail.value.trim(),
                contact_name : this.$refs.ipContactName.value.trim(),
                contact_phone  : this.$refs.ipcontactPhone.value.trim(),
                communication_mode : this.$refs.ipCommunicationMode.value.trim(),
                security_code :  this.$refs.ipSecurityCode.value.trim(),
                name :  this.$refs.ipName.value.trim(),
                endpoint_url :  this.$refs.ipEndPointUrl.value.trim(),
                active : this.activeStatusSelected ,
                mode :   this.modeTypeSelected,
                xref_code :  this.$refs.ipXrefCode.value.trim(),
                received_location : this.$refs.ipReceivedLocation.value.trim(),
                supplier_identity : this.$refs.ipSupplierIdentity.value.trim(),
                buyer_identity : this.$refs.ipBuyerIdentity.value.trim()
                  
                }, 
                 "headers": 
                  { 
                    "content-type": "application/json" ,
                    "authorization": "bearer " + localStorage.getItem('id_token') 
                  }  }).then
                (
                  result => {
                    if(result.data[0].result_Code == "1"){
                    sweetAlert(result.data[0].result_Output, '', 'success')
                    this.resetControls();}
                    else if(result.data[0].result_Code == "2"){
                    sweetAlert('', result.data[0].result_Output, 'error');
                   }
                 }, 
                error => {
                console.error(error.response);
                 sweetAlert('Something\'s Wrong!', error, 'error')
                });
        
      })}

    },
 
    onClose(){
      this.resetControls ();
    }

   
  },
   created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
     this.partnerTypeSelected = "0";
     this.modeTypeSelected = "QA";
     this.activeStatusSelected = "1";
     
     
     }
  }
}
</script> 


// WEBPACK FOOTER //
// src/components/manage-cxml/AddPartner.vue